import React from 'react'
import cx from 'classnames'

import BuyTry from '@/components/blocks/BuyTry'
import { Column, Layout, Section } from '@/components/layout'
import { Text } from '@/components/common'
import PricingMain from '@/components/blocks/PricingMain'
import HomePageStats from '@/components/Pages/HomePage/HomePageStats'
import HomePageQuotes from '@/components/Pages/HomePage/HomePageQuotes'
import styles from '@/components/Pages/HomePage/HomePage.module.scss'
import BuyNowCta from '@/components/BuyNowCta'
import FeatureRows from '@/components/sections/FeatureRows'

const pageId = 'renew'
const getMessageId = (id) => `pages.home.${id}`
const buyCtaMessageId = 'cta.buyNowRenew'

const promocode = 'RENEW50'

const PromoBuyButton = (props) => (
  <BuyTry
    buyCtaMessageId={buyCtaMessageId}
    canTry={false}
    className={styles.headerBuyTry}
    promocode={promocode}
    {...props}
  />
)

export default function Renew() {
  return (
    <Layout.Content>
      <Section className={styles.headerSection} wrapperClassName={styles.headerWrapper}>
        <Column className="w-full">
          <div className={styles.heroHolder}>
            <div className="max-w-700">
              <Text.H1 brandPrimary messageId={getMessageId('main.header.title')} normal size="medium" />
              <Text.H2 messageId="pages.fbRenew.main.header.subtitle" size="xlarge" />
              <div className={styles.promoBtContainer}>
                <PromoBuyButton justifyStart />
                <Text.P>$200 Value</Text.P>
              </div>
            </div>
          </div>
        </Column>
      </Section>

      <Section wrapperClassName={styles.featuresWrapper}>
        <h2>Report expenses, manage<br />
          documents, and much more!
        </h2>

        <FeatureRows />
      </Section>

      <HomePageStats replaceCtasWith={
        <div className={styles.promoBtContainer}>
          <BuyNowCta messageId={buyCtaMessageId} promocode={promocode} variant="success" />
          <Text.P>$200 Value</Text.P>
        </div>
      }
      />
      <HomePageQuotes />
      <Section className={styles.securitySection} wrapperClassName={styles.securityWrapper}>
        <div className={cx(styles.securityTextWrapper, 'max-w-600')}>
          <Text.H2 brandSecondary messageId={getMessageId('security.title')} normal />
          <Text.P messageId={getMessageId('security.p')} onTint />
        </div>
      </Section>
      <Section bgBrandTertiary style={{ backgroundColor: '#E9E8FF' }}>
        <PricingMain
          buyCtaMessageId={buyCtaMessageId}
          canTry={false}
          hideLogos
          learnMoreBt={false}
          price="$150/year"
          promocode={promocode}
          strikeThrough="$200"
        />
      </Section>
    </Layout.Content>
  )
}

Renew.layoutProps = {
  pageId,
  logoOnlyHeader: true,
  showFooter: false,
  shouldRobotsIndex: false,
}
